export type EmbeddedPlatform = 'vk' | 'max';

export interface AppEntry {
  readonly basename: string;
  readonly platform: EmbeddedPlatform;
}

const entries: readonly AppEntry[] = [
  { basename: '/app/vk', platform: 'vk' },
  { basename: '/app/max', platform: 'max' },
];

export const resolveAppEntry = (pathname: string): AppEntry | null =>
  entries.find(
    (entry) => pathname === entry.basename || pathname.startsWith(`${entry.basename}/`),
  ) ?? null;

export const legacyEmbeddedRedirect = (
  pathname: string,
  platform: EmbeddedPlatform | null,
  search: string,
  hash: string,
): string | null => (pathname === '/' && platform ? `/app/${platform}${search}${hash}` : null);
